import React from 'react';
import Icon from '../../../components/AppIcon';

const ReportSuccessModal = ({ show, onClose }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-surface rounded-lg max-w-md w-full p-6">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center w-12 h-12 rounded-full bg-green-100 mb-4">
            <Icon name="Check" size={24} className="text-green-600" />
          </div>
          
          <h3 className="text-lg font-semibold text-text-primary mb-2">
            Report Submitted Successfully
          </h3>
          
          <p className="text-text-secondary mb-6">
            Thank you for helping keep VA Sprouts safe. Our moderation team will review your report and take appropriate action if necessary.
          </p>
          
          <button
            onClick={onClose}
            className="w-full px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-600 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReportSuccessModal;